import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'
import vocList from './modules/voc-list'

Vue.use(Vuex)

export default new Vuex.Store({
	// plugins: [createPersistedState()],
	modules: {
		vocList
	}
})